import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton } from '../../../../components/action-button';
import { IconSquareEditOutline } from '../../../../common/icons';
import { ROUTE_OPEN_INFO_UPDATE } from '../../../../common/constants';
import { url } from '../../../../common/utils';
import { IOpenInfo } from '../../models';

interface OpenInfoActionEditProps {
  id: IOpenInfo['id'];
}

export const OpenInfoActionEdit: FC<OpenInfoActionEditProps> = ({ id }) => {
  const { t } = useTranslation();

  return (
    <ActionButton
      to={url(ROUTE_OPEN_INFO_UPDATE, { id })}
      title={t('action.edit')}
      icon={<IconSquareEditOutline />}
    />
  );
};
